export default __webpack_public_path__ + "static/media/OTIS_Logo.bb873ca8.png";